import gql from 'graphql-tag';

export const VOLATILITY_MEASURES = gql`
    query VolatalityMeasures($ticker: String!) {
        mutualFund(ticker: $ticker) {
            threeYearRiskMeasure {
                rSquared
                beta
                alpha
                standardDeviation
                activeShare
            }
            earningsGrowthRate3Years
            earningsPerShareGrowthCurrentFiscalYear
            monthlyComponentsAsOfDate
            priceEarningsRatio
            priceEarningsRatioCurrentFiscalYear
            trpFund
            turnoverRate
            turnoverRateTwelveMonth
            morningStarRatings {
                morningStarCategoryName
            }
        }
    }
`;

export const ETF_VOLATILITY_MEASURES = gql`
    query VolatalityMeasures($ticker: String!) {
        exchangeTradedFund(ticker: $ticker) {
            price {
                outstandingShares
            }
            benchmarks {
                benchmarkCode
                benchmarkName
                benchmarkType
            }
            riskMeasure {
                asOfDate
                fundRiskMeasure {
                    standardDeviation
                    rSquared
                    beta
                }
                benchmarkRiskMeasure {
                    benchmarkCode
                    standardDeviation
                    rSquared
                    beta
                }
            }
            portfolioCharacteristics {
                fundPortfolioCharacteristic {
                    weightedAverageMarketCap
                }
            }
        }
    }
`;

export const FI_ETF_VOLATILITY_MEASURES = gql`
    query VolatalityMeasures($ticker: String!) {
        exchangeTradedFund(ticker: $ticker) {
            price {
                outstandingShares
            }
            benchmarks {
                benchmarkCode
                benchmarkName
                benchmarkType
            }
            riskMeasure {
                asOfDate
                fundRiskMeasure {
                    standardDeviation
                    rSquared
                    beta
                    alpha
                }
                benchmarkRiskMeasure {
                    benchmarkCode
                    standardDeviation
                    rSquared
                    beta
                    alpha
                }
            }
            portfolioCharacteristics {
                fundPortfolioCharacteristic {
                    weightedAverageMarketCap
                }
            }
        }
    }
`;
